import {
  CommonRequest,
  Method,
  ServiceName,
  CommonResponse,
  DmlResponse,
} from 'models/common/RestApi';
import { SearchParam, UtMatrixEumTagId } from 'models/ut/UtMatrixEumTagId';
import { callApi } from 'utils/ApiUtil';

export const getUtMatrixEumTagIdList = async (searchParam: SearchParam) => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/ut/getUtMatrixEumTagIdList`,
    serviceName: ServiceName.ELM_BE,
    queryParams: new URLSearchParams({
      ...searchParam,
    }),
  };
  const response: CommonResponse<UtMatrixEumTagId[]> = await callApi(request);
  return (response.successOrNot === 'Y' ? response.data : null) as UtMatrixEumTagId[];
};

export const saveUtMatrixEumTagList = async (saveData: UtMatrixEumTagId[]) => {
  const request: CommonRequest = {
    method: Method.POST,
    url: `/v1/ut/saveUtMatrixEumTagList`,
    serviceName: ServiceName.ELM_BE,
    bodyParams: saveData,
  };
  const response: CommonResponse<DmlResponse> = await callApi(request);

  return (response.successOrNot === 'Y' ? response.data : null) as DmlResponse;
};

export const checkDuplicationEumTagMapping = async (saveData: UtMatrixEumTagId[]) => {
  const request: CommonRequest = {
    method: Method.POST,
    url: `/v1/ut/checkDuplicationEumTagMapping`,
    serviceName: ServiceName.ELM_BE,
    bodyParams: saveData,
  };
  const response = await callApi(request);
  return response.data;
};
